import { INIT } from './view'
import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/MyBoard/cards/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE_ARRAY = NAMESPACE + 'REMOVE_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET = NAMESPACE + 'SET'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_DUE_DATE = NAMESPACE + 'SET_DUE_DATE'
export const INCREASE_FILE_COUNT = NAMESPACE + 'INCREASE_FILE_COUNT'
export const DECREASE_FILE_COUNT = NAMESPACE + 'DECREASE_FILE_COUNT'
export const INCREASE_CHECKLIST_ITEM_COUNT = NAMESPACE + 'INCREASE_CHECKLIST_ITEM_COUNT'
export const DECREASE_CHECKLIST_ITEM_COUNT = NAMESPACE + 'DECREASE_CHECKLIST_ITEM_COUNT'
export const INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT = NAMESPACE + 'INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT'
export const DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT = NAMESPACE + 'DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT'
export const INCREASE_NOTE_COUNT = NAMESPACE + 'INCREASE_NOTE_COUNT'
export const DECREASE_NOTE_COUNT = NAMESPACE + 'DECREASE_NOTE_COUNT'
export const INCREASE_COMMENT_COUNT = NAMESPACE + 'INCREASE_COMMENT_COUNT'
export const DECREASE_COMMENT_COUNT = NAMESPACE + 'DECREASE_COMMENT_COUNT'
export const SET_RESPONSIBLE = NAMESPACE + 'SET_RESPONSIBLE'
export const SET_POSITIONS = NAMESPACE + 'SET_POSITIONS'
export const ADD_USER = NAMESPACE + 'ADD_USER'
export const REMOVE_USER = NAMESPACE + 'REMOVE_USER'

export const initialState = {}

export const cardDefaults = {
  position: 0,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...initialState
      }
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...cardDefaults,
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      let newState = {
        ...state
      }
      action.payload.forEach(card => {
        newState[card.id] = {
          ...cardDefaults,
          ...card
        }
      })
      return newState
    }
    case REMOVE_ARRAY: {
      let newState = {
        ...state
      }
      action.payload.forEach(id => {
        delete newState[id]
      })
      return newState
    }
    case REMOVE: {
      let newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case SET:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ...action.payload.data
        }
      } : state
    case SET_NAME:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          name: action.payload.name
        }
      } : state
    case SET_DUE_DATE:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          dueDate: action.payload.dueDate
        }
      } : state
    case INCREASE_FILE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          fileCount: state[action.payload.id].fileCount + action.payload.count
        }
      } : state
    case DECREASE_FILE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          fileCount: state[action.payload.id].fileCount - action.payload.count
        }
      } : state
    case INCREASE_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          checklistItemCount: state[action.payload.id].checklistItemCount + action.payload.count
        }
      } : state
    case DECREASE_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          checklistItemCount: state[action.payload.id].checklistItemCount - action.payload.count
        }
      } : state
    case INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          completedChecklistItemCount: state[action.payload.id].completedChecklistItemCount + action.payload.count
        }
      } : state
    case DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          completedChecklistItemCount: state[action.payload.id].completedChecklistItemCount - action.payload.count
        }
      } : state
    case INCREASE_NOTE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          noteCount: state[action.payload.id].noteCount + action.payload.count
        }
      } : state
    case DECREASE_NOTE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          noteCount: state[action.payload.id].noteCount - action.payload.count
        }
      } : state
    case INCREASE_COMMENT_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          commentCount: state[action.payload.id].commentCount + action.payload.count
        }
      } : state
    case DECREASE_COMMENT_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          commentCount: state[action.payload.id].commentCount - action.payload.count
        }
      } : state
    case SET_RESPONSIBLE: {
      if (
        !state[action.payload.id] ||
        state[action.payload.id].responsible === action.payload.responsible
      ) return state

      const newCardStart = {
        ...state[action.payload.id]
      }

      if (state[action.payload.id].responsible) {
        newCardStart.users = addUniqueValueToArray({
          array: newCardStart.users,
          value: state[action.payload.id].responsible
        })
      }

      if (state[action.payload.id].users.indexOf(action.payload.responsible) !== -1) {
        newCardStart.users = newCardStart.users.filter(id => id !== action.payload.responsible)
      }

      newCardStart.responsible = action.payload.responsible

      return {
        ...state,
        [action.payload.id]: newCardStart
      }
    }
    case SET_POSITIONS: {
      const newState = {
        ...state
      }
      action.payload.positions.forEach(pos => {
        if (newState[pos.id]) {
          newState[pos.id] = {
            ...newState[pos.id],
            position: pos.position
          }
        }
      })
      return newState
    }
    case ADD_USER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          users: addUniqueValueToArray({
            array: state[action.payload.id].users,
            value: action.payload.userId,
            index: action.payload.index
          })
        }
      } : state
    case REMOVE_USER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          users: state[action.payload.id].users.filter(id => id !== action.payload.userId)
        }
      } : state
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (cardArray) {
  return {
    type: ADD_ARRAY,
    payload: cardArray
  }
}

export function removeArray (cardArray) {
  return {
    type: REMOVE_ARRAY,
    payload: cardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function set ({ id, data }) {
  return {
    type: SET,
    payload: {
      id,
      data
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setDueDate ({ id, dueDate }) {
  return {
    type: SET_DUE_DATE,
    payload: {
      id,
      dueDate
    }
  }
}

export function increaseFileCount ({ id, count = 1 }) {
  return {
    type: INCREASE_FILE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseFileCount ({ id, count = 1 }) {
  return {
    type: DECREASE_FILE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseChecklistItemCount ({ id, count = 1 }) {
  return {
    type: INCREASE_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseChecklistItemCount ({ id, count = 1 }) {
  return {
    type: DECREASE_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseCompletedChecklistItemCount ({ id, count = 1 }) {
  return {
    type: INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseCompletedChecklistItemCount ({ id, count = 1 }) {
  return {
    type: DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseNoteCount ({ id, count = 1 }) {
  return {
    type: INCREASE_NOTE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseNoteCount ({ id, count = 1 }) {
  return {
    type: DECREASE_NOTE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseCommentCount ({ id, count = 1 }) {
  return {
    type: INCREASE_COMMENT_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseCommentCount ({ id, count = 1 }) {
  return {
    type: DECREASE_COMMENT_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function setResponsible ({ id, responsible }) {
  return {
    type: SET_RESPONSIBLE,
    payload: {
      id,
      responsible
    }
  }
}

export function setPositions (positions) {
  return {
    type: SET_POSITIONS,
    payload: {
      positions
    }
  }
}

export function addUser ({ id, userId, index }) {
  return {
    type: ADD_USER,
    payload: {
      id,
      userId,
      index
    }
  }
}

export function removeUser ({ id, userId }) {
  return {
    type: REMOVE_USER,
    payload: {
      id,
      userId
    }
  }
}
